import { between } from "polished";
// import imageUrlBuilder from '@sanity/image-url';
import { breakpoints } from "./variables.css";

const cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

export default function getValueAndUnit(value: string | number): any {
  if (typeof value !== "string") return [value, ""];
  const matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */
// export function betweenContainer(
//   fromSize: string | number,
//   toSize: string | number,
//   minScreen: string = '320px',
//   maxScreen: string = '1200px',
// ): string {
//   const [unitlessFromSize, fromSizeUnit] = getValueAndUnit(fromSize)
//   const [unitlessToSize, toSizeUnit] = getValueAndUnit(toSize)
//   const [unitlessMinScreen, minScreenUnit] = getValueAndUnit(minScreen)
//   const [unitlessMaxScreen, maxScreenUnit] = getValueAndUnit(maxScreen)

//   if (
//     typeof unitlessMinScreen !== 'number'
//     || typeof unitlessMaxScreen !== 'number'
//     || !minScreenUnit
//     || !maxScreenUnit
//     || minScreenUnit !== maxScreenUnit
//   ) {
//     throw new Error('47')
//   }

//   if (
//     typeof unitlessFromSize !== 'number'
//     || typeof unitlessToSize !== 'number'
//     || fromSizeUnit !== toSizeUnit
//   ) {
//     throw new Error('48')
//   }

//   if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) {
//     throw new Error('76')
//   }

//   const slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen)
//   const base = unitlessToSize - slope * unitlessMaxScreen
//   return `calc(${base.toFixed(2)}${fromSizeUnit || ''} + ${(100 * slope).toFixed(2)}cqw)`
// }

// export const fluidContainer = (min: string, max: string, from = breakpoints.mobile, to = breakpoints.desktop) => {
//   return `clamp(${min}, ${betweenContainer(min, max, from, to)}, ${max})`
// }

export const fluid = (
  min: string,
  max: string,
  from = breakpoints.mobile,
  to = breakpoints.desktop
) => {
  const [minValue, minUnit] = getValueAndUnit(min);
  const [maxValue, maxUnit] = getValueAndUnit(max);
  const minLargest = Math.min(minValue, maxValue) + minUnit;
  const maxLargest = Math.max(minValue, maxValue) + maxUnit;

  return `clamp(${minLargest}, ${between(min, max, from, to)}, ${maxLargest})`;
};

// export const fluidPercentage = (min: string, max: string, from = breakpoints.mobile, to = breakpoints.desktop) => {
//   const [minValue] = getValueAndUnit(min)
//   const [maxValue] = getValueAndUnit(max)
//   const [fromValue] = getValueAndUnit(from)
//   const [toValue] = getValueAndUnit(to)
//   const minLargest = Math.min(minValue, maxValue)
//   const maxLargest = Math.max(minValue, maxValue)

//   return `clamp(${minLargest / fromValue * 100}%, ${between(min, max, from, to)}, ${maxLargest / toValue * 100}%)`
// }

export const truncate = (string: string, length = 159, suffix = "...") => {
  if (string.length > length) {
    return string.substring(0, length) + suffix;
  }
  return string;
};

export const getPageSlug = (slug?: string, type?: string) => {
  if (slug) {
    if (type && type !== "page") {
      return "/" + type + "/" + slug;
    } else {
      if (slug === "/") {
        return slug;
      } else {
        return "/" + slug;
      }
    }
  }
  return "";
};

export const formatDate = (dateTime: string | undefined) =>
  dateTime
    ? new Date(dateTime).toLocaleDateString("en-UK", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

export const formatTime = (dateTime: string | undefined) =>
  dateTime
    ? new Date(dateTime)
        .toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
        .replace(" AM", "am")
        .replace(" PM", "pm")
    : "";

export const convertToPlainText = (text: string) => {
  const plainText = text
    // .replace(/<br>/g, " ") // Replace <br> tags with a space
    .replace(/<[^>]*>/g, ""); // Remove all other HTML tags
  return plainText;
};
